import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Icon, Spin } from 'antd';
import { TitleText, BasicText, ShortInput, LongInput, CopyUrl, BasicButton } from '@components';
import styles from './GroupHome.module.css';

const GroupTable = ({ groups, onDeleteGroup }) => {
  const getGroupTableData = () => {
    let dataArray = [];
    groups.forEach((group, i) => {
      dataArray.push({
        id: group.id,
        name: group.name,
        photo_url: group.photo_url,
        created: group.created,
        members: group.members,
        entry_count: group.entries
      })
    });
    return dataArray;
  }

  const getColumns = () => {
    let columns = [
      {
        title: 'Group',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        render(text, record) {
          return {
            children: <div style={{ display: "flex", alignItems: 'center', maxWidth: 150, overflow: 'hidden' }}>
                        <img src={record.photo_url} style={{ width: 30, height: 30, borderRadius: 6, marginRight: 12 }} />
                        <BasicText fontSize="13px" bold>{text}</BasicText>
                      </div>
          };
        }
      },
      {
        title: 'Created',
        dataIndex: 'created',
        key: 'created',
        width: 90,
        render(text, record) {
          return {
            children: <BasicText fontSize="12px">{text}</BasicText>,
          };
        }
      },
      {
        title: 'Members',
        dataIndex: 'members',
        key: 'members',
        width: 90,
        render(text, record) {
          return {
            children: <div style={{ maxWidth: 90, overflow: 'hidden' }}>
                        <BasicText fontSize="12px">{text}</BasicText>
                      </div>,
          };
        }
      },
      {
        title: 'Entries',
        dataIndex: 'entry_count',
        key: 'entry_count',
        width: 120,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{text}</BasicText>,
          };
        }
      },
      {
        title: 'Delete',
        dataIndex: 'delete',
        key: 'delete',
        width: 120,
        render(text, record) {
          return {
            children: <BasicButton
                        text="Delete"
                        type="danger"
                        onClick={() => onDeleteGroup(record)}
                      />,
          };
        }
      }

    ];

    return columns;
  }

  return (
    <div className={styles.table_container_style}>
      <Table
        pagination={false}
        columns={getColumns()}
        dataSource={getGroupTableData()}
        rowKey="id"
      />
    </div>
  )
}

export default GroupTable;
